
import './App.css';
import { Routes,Route, useLocation} from 'react-router-dom';
import { useState,useEffect } from 'react';
// import { ProtectedRoute, PublicRoute } from './src/utilities';

import { Link }from 'react-router-dom'
import NavigationMenuDemo from './components/NavigationMenuDemo.js';
import { TracingBeamDemo } from './components/TraceBeamDemo';
import Home from './components/pages/Home';
import WhatWeDo from './components/pages/WhatWeDo';
import WhoWeAre from './components/pages/WhoWeAre';
import HomeNav from './components/nav/HomeNav';
import LatestNewsNav from './components/nav/LatestNewsNav';
import WhoWeAreNav from './components/nav/WhoWeAreNav';
import WhatWeDoNav from './components/nav/WhatWeDoNav';
import SubCategoryPage from './components/pages/SubCategoryPage';
import ArticlePage from './components/pages/ArticlePage';
import StoriesPage from './components/pages/ArticlePage';
import SidebarLayout from './components/sections/SidebarLayout';
import HomeJ from './components/sections/HomeJ';
import Footer from './components/sections/Footer';
import DonateButton from './components/sections/DonateButton';
import { ProtectedRoute } from './utilities/ProtectedRoute';
import SignIn from './components/pages/SignIn';
import PasswordResetForm from './components/pages/PasswordResetForm';
import PassResetConfirm from './components/pages/PassResetConfirm';
import ProjectSubCategoryPage from './components/pages/ProjectSubCategoryPage';
import ArticlePublicRead from './components/pages/ArticlePublicRead';
import ProjectGrid from './components/sections/ProjectGrid';
import CampaignPublicReadPage from './components/pages/CampaignPublicReadPage';
import KenyaProjectsMapH from './components/sections/KenyaProjectMapH';
import WhereWeWork from './components/nav/WhereWeWork';
import ResourcePublicRead from './components/pages/ResourcePublicRead';
import VolunteerPage from './components/forms/VolunteerPage';
import ScrollToTop from './components/sections/ScrollToTop';

// import { Header, Segment } from 'semantic-ui-react'
// import BreadcrumbsNav from './components/BreadcrumbsNav';
// import TeachingCenter from './components/TeachingCenter';

// import { useAuth } from './hooks/useAuth';
// import { useNavigationTab } from './hooks/useNavigationTab';

function App() {
  // const {user,logout}=useAuth()
  // const {customNavigate} = useNavigationTab()
  const location = useLocation()
  const [isSubCategoryPage,setIsSubCategoryPage]  = useState(false)

  useEffect(()=>{
    let isWhoWeDoPage = location?.pathname?.includes("in");
    setIsSubCategoryPage(isWhoWeDoPage)

  },[location])

  

  const [isSticky, setIsSticky] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // console.log(location?.state?.img)
  return (
    <div 
    // className={isSubCategoryPage?'App1':'App'}
    className='App'
    >
      <ScrollToTop />  {/* << Add this here */}
      
      {isSubCategoryPage?
      
      <header className={`main-header ${isSubCategoryPage? "overlay" : "solid"}`}>
      <div className="nav-container">
        <div className="logo"><img src="https://file.fountainafrica.org/wp-content/uploads/2025/11/FAT%20Logo.jpg" alt="" width={141} height={89}/></div>

        <nav className="nav-links">
          <HomeNav recolor={true}/>
          <WhoWeAreNav recolor={true}/>
          <WhatWeDoNav recolor={true}/>
          <WhereWeWork recolor={true}/>
          <LatestNewsNav recolor={true}/>
          {/* <DonateButton/> */}
        </nav>
      </div>
    </header>
      :
      
      <header className={isSubCategoryPage?'maintain-header App-header1':' maintain-header App-header'}>
      {/* <div className='align-row'> */}
      <div className='site-logo'>
        {/* <img src="/FATLogo.jpg" alt="" width={212} height={134}/> */}
        <img src="https://file.fountainafrica.org/wp-content/uploads/2025/11/FAT%20Logo.jpg" alt="" width={141} height={89}/>
      </div>
      
      <div className='site-nave'>
      {/* <NavigationMenuDemo/> */}
       <HomeNav/>
       <WhoWeAreNav/>
       <WhatWeDoNav/>
       <WhereWeWork/>
       <LatestNewsNav/>
       <DonateButton/>
      </div>
      {/* </div> */}
      </header>}

      {/* <div className='App-header1'>
      <img src="/FATLogo.jpg" alt="" width={141} height={89}/>
      </div>

      
      <h1 class="text-3xl font-bold underline">
        Hello world!
      </h1> */}
      <div className="App-body">
         
        <Routes>
        
          {/* <Route element={<ProtectedRoute />}>
            <Route path="/" element={<StudentHome/>} />
          </Route> */}
          
          {/* <Route path="/" element={<h1>Welcome</h1>}/> */}
          <Route path="/" element={<Home/>}/>
          
          <Route path="/what-we-do/" element={<WhatWeDo/>}/>

          <Route path="/what-we-do/:category/" element={<WhatWeDo/>}/>

          <Route path="/who-we-are/" element={<WhoWeAre/>}/>

          <Route path="/where-we-work/" element={<KenyaProjectsMapH/>}/>

          {/* <Route path="/who-we-are/:category" element={<WhoWeAre/>}/> */}

          <Route path="/what-we-do-in/:subcategory/" element={<SubCategoryPage/>}/>

          <Route path="/projects/:project_title/" element={<SubCategoryPage isProject={true}/>}/>

          <Route path="/projects/" element={<ProjectGrid/>}/>
          <Route path="/projects/:project_title/:id/" element={<ProjectSubCategoryPage isProject={true}/>}/>

          <Route path="/articles/:article_title/" element={<ArticlePage/>}/>

          <Route path="/articles/:article_title/:id/" element={<ArticlePublicRead/>}/>

          <Route path="/campaign/:campaign_title/" element={<ArticlePage isCampaign={true}/>}/>
          <Route path="/campaign/:campaign_title/:id/" element={<CampaignPublicReadPage isCampaign={true}/>}/>
          
          <Route path="/resource/detail/:id/" element={<ResourcePublicRead/>}/>

          <Route path="/news/:news_title/" element={<ArticlePage isNews={true}/> }/>

          <Route element={<ProtectedRoute />}>
          
            <Route path="/staff/" element={<SidebarLayout />}/>
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/staff/:nav/" element={<SidebarLayout />}/>
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/staff/:nav/:action/" element={<SidebarLayout />}/>
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/staff/:nav/:action/:detail/" element={<SidebarLayout />}/>
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route path="/staff/:nav/:action/:detail/:id/" element={<SidebarLayout />}/>
          </Route>
          {/* <Route path="/staff/:nav/:action/:id/" element={<SidebarLayout />}/> */}

          <Route path="/test/" element={<HomeJ />}/>

          <Route path="/signin/" element={<SignIn/>}/>
          
          <Route path="/password_reset/" element={<PasswordResetForm/>}/>

          <Route path="/password-reset/confirm/" element={<PassResetConfirm/>}/>

          <Route path="/getinvolved/" element={<VolunteerPage/>}/>
          
        </Routes>
        
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
